<template>
    
    <span class="sorter"
        :class="{ 'active': active }"
        @click="sort">

        <span class="sorter__label">
            <slot></slot>
        </span>

        <span class="sorter__indicator"
            v-if="!active">
            <i class="sort-by-asc" />
            <i class="sort-by-desc" />
        </span>
        <span class="sorter__indicator"
            v-if="active && orderBy === 'DESC'">
            <i class="sort-by-desc" />
        </span>
        <span class="sorter__indicator"
            v-if="active && orderBy === 'ASC'">
            <i class="sort-by-asc" />
        </span>

    </span>

</template>

<script>
import Vue from 'vue';

export const ORDER = {
    ASC: 'ASC',
    DESC: 'DESC'
}

export const SORT_EVENT = 'sort'

export const SortBus = new Vue();

export default {

    props: {

        criteria: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            active: false,
            orderBy: null
        }
    },
    
    methods: {

        asc: function() {
            this.orderBy = ORDER.ASC
            this.fireChange()
        },

        desc: function() {
            this.orderBy = ORDER.DESC
            this.fireChange()
        },

        sort: function() {

            if ( this.active ) {
                if ( this.orderBy === ORDER.DESC ) {
                    this.asc()
                }
                else {
                    this.desc()
                }

                return
            }
            
            this.active = true 
            this.orderBy = ORDER.ASC           
            this.fireChange()
        },

        fireChange: function() {
            let sort = {
                label: this.$el.querySelector('.sorter__label').innerText,
                orderBy: this.orderBy,
                sortBy: this.criteria
            }

            this.$emit(SORT_EVENT, sort)
            SortBus.$emit(SORT_EVENT, sort)
        }
    },

    created() {
        SortBus.$on(SORT_EVENT, sort => {
            this.active = ( sort.sortBy === this.criteria )
            this.orderBy = ( this.active ) ? sort.orderBy : null
        })
    }
}

</script>

<style>

.sorter {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.sorter:hover {
    cursor: pointer;
}

.sorter .sorter__label {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sorter .sorter__indicator {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
}

.sort-by-asc
{
    left: 3px;
    display: inline-block;
    width: 0;
    height: 0;
    border: solid 5px transparent;
    margin: 4px 4px 0 3px;
    background: transparent;
    border-bottom: solid 5px gray;
    border-top-width: 0;
}

.sort-by-desc
{
    left: 3px;
    display: inline-block;
    width: 0;
    height: 0;
    border: solid 5px transparent;
    margin: 2px 4px 0 3px;
    background: transparent;
    border-top: solid 5px gray;
    border-bottom-width: 0;
}

.sorter.active .sort-by-asc {
    border-bottom-color: #0dc5c1;
    border-bottom-width: 7px;
    margin-bottom: 1px;
}

.sorter.active .sort-by-desc {
    border-top-color: #0dc5c1;
    border-top-width: 7px;
}

</style>